module.exports = __webpack_public_path__ + "img/2.8c3b23d4.png";